import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CollectionQueryForm from 'Components/ComponentLibrary/Molecules/CollectionQueryForm';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  CheckboxMultiPicklist,
} from 'Views/Page/Content/Templates/HouseholdBalanceSheetPageTemplate/filters/CheckboxMultiPicklist';
import { HouseholdBalanceSheetFilterLayout } from './HouseholdBalanceSheetFilterLayout';

const metaOverrideSet = buildFacetDesignOverride()
  .typeOverride('multipicklist', { _component: () => CheckboxMultiPicklist }, overrideReadOnly);

export const HouseholdBalanceSheetFilters = ({
  collection, setCollection,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <CollectionQueryForm
      removeEmptyQueryParams
      component="div"
      collection={collection}
      onSubmit={(newCollection) => {
        setOpen(false);
        setCollection(newCollection);
      }}
      LayoutProps={{
        open,
        setOpen,
      }}
      layout={HouseholdBalanceSheetFilterLayout}
      metaOverrideSet={metaOverrideSet}
      formPadding="none"
      formMargin="none"
    />
  );
};

HouseholdBalanceSheetFilters.defaultProps = {
};

HouseholdBalanceSheetFilters.propTypes = {
  collection: PropTypes.object.isRequired,
  setCollection: PropTypes.func.isRequired,
};
